import React from 'react';
import classes from '../../drawer.scss';
export default class HiddenChildren extends React.Component {
  componentDidCatch() {
    // eslint-disable-next-line no-console
    console.log('Failed to render hidden for crawlers data');
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.displayNone
    }, this.props.dataToDisplay);
  }
}